import { render } from "./BaseReferenceTable.vue?vue&type=template&id=a00e0a98&scoped=true"
import script from "./BaseReferenceTable.vue?vue&type=script&lang=js"
export * from "./BaseReferenceTable.vue?vue&type=script&lang=js"

import "./BaseReferenceTable.vue?vue&type=style&index=0&id=a00e0a98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a00e0a98"]])

export default __exports__